<template>

   <!-- <div class="modal-dialog">
      <div class="modal-content">

         <div class="modal-header justify-content-end" style="background-color: #00A0C1; height:50px;">
            <div>
               <button type="button" ref="closeModal" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="resetForm()"></button>
            </div>
         </div>
         
         <div class="modal-body"> -->

            <div class="row text-center justify-content-center">
               <h1 class="modal-title"><strong> Group </strong></h1>
            </div>

            <hr />

            <form class="row mx-4 g-0" style="gap: 1rem">

               <div class="form-floating">
                  <input type="text" id="groupName" v-model.trim="group.name" @blur="v$.group.name.$touch"
                     class="form-control" placeholder="Group Name" :disabled="isEditing" @input="isUnique.name=true"/>
                  <label for="groupName" class="text-muted">Group Name</label>
                  <div class="pt-1">
                     <span class="form-text" :class="{'text-danger' : v$.group.name.alphaNumericUnderscore.$invalid, 
                        'text-muted' : !v$.group.name.alphaNumericUnderscore.$invalid}">
                        Minimum of 3 characters long. Must contain letters, numbers and underscores only.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.group.name.required.$invalid && v$.group.name.$dirty">
                        Group Name is required.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.name">
                        Group Name already exists.
                     </span>
                  </div>
                  
               </div>
               
               <div class="form-floating">
                  <input type="text" id="displayName" v-model.trim="group.displayName" @blur="v$.group.displayName.$touch"
                     class="form-control" placeholder="Display Name" @input="isUnique.displayName=true"/>
                  <label for="displayName" class="text-muted">Display Name</label>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="v$.group.displayName.required.$invalid && v$.group.displayName.$dirty">
                        Display Name is required.
                     </span>
                  </div>

                  <div class="pt-1">
                     <span class="form-text text-danger" v-if="!isUnique.displayName">
                        Display Name already exists.
                     </span>
                  </div>
                  
               </div>
               
               <div class="pt-2 pb-2 justify-content-center d-flex" style="gap:0.5rem">
                  <button  v-if="!isEditing" type="button" class="btn btn-outline-warning" @click="resetForm()">Clear fields</button>
                  <button v-if="!isEditing" type="button" class="btn btn-info text-light"
                     @click="createGroup()" :disabled="disableFormButton()"> Create </button>
                  <button v-if="isEditing" type="button" class="btn btn-info text-light"
                     @click="updateGroup(group.id)" :disabled="disableFormButton()"> Update </button>
               </div>
            </form>

         <!-- </div>
      </div>
   </div> -->

   <ConfirmModal
      v-model="showConfirmModal"
      :title="confirmModalTitle"
      :message="confirmModalMessage"
      @confirm="onConfirmAction"
   />
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, helpers } from '@vuelidate/validators'

const alphaNumericUnderscore = helpers.regex(/^[a-zA-Z0-9][\w]+[a-zA-Z0-9]$/) //matches alphaNumeric and underscores

export default ({

   setup () {
      return { v$: useVuelidate() }
   },

   data(){
      return{
         group: {
            id: '',
            name: '',
            displayName: '',
         },
         groups: [],
         isUnique: {
            name: true,
            displayName: true,
         },
         isEditing: false,
         showConfirmModal: false,
         confirmModalTitle: '',
         confirmModalMessage: '',
         pendingDeleteId: null,
      }
         
   },

   validations() {
      return {
         group: {
            name: { required, alphaNumericUnderscore },
            displayName: { required },
         },
      }
   },

   methods: {

      isCreate(){
         this.isEditing = false
      },

      isEdit(id){
         this.isEditing = true
         this.getGroup(id)
      },

      isDelete(id){
         this.deleteGroup(id)
      },

      async getGroup(id) {

         await this.$axios.get("/groups/"+id)
         .then((response) => {
            this.group.id = response.data.group.id
            this.group.name = response.data.group.name
            this.group.displayName = response.data.group.display_name
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })

      },

      resetForm() {
         this.v$.$reset()
         this.group.id = ""
         this.group.name = ""
         this.group.displayName = ""
         this.isEditing = false
         this.isUnique.name = true
         this.isUnique.displayName = true
      },

      disableFormButton() {
         if (this.v$.$invalid || this.v$.$error){
            return true
         }

         return false
      },

      async createGroup() {

         let group = {
            name : this.group.name,
            display_name : this.group.displayName,
         }

         await this.$axios.post("/groups",group)
         .then((response) => {

            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$refs.closeModal.click();
               this.resetForm()

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })

      },

      async updateGroup(id) {

         let group = {
            display_name : this.group.displayName,
         }

         await this.$axios.put("/groups/"+id, group)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)
               
               this.$refs.closeModal.click();
               this.resetForm();

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.checkError(error)
         })

      },

      async deleteGroup(id) {
         this.pendingDeleteId = id;
         this.confirmModalTitle = 'Delete Group';
         this.confirmModalMessage = 'Do you want to delete this group?\n\nAll categories and subcategories under this group will also be deleted.';
         this.showConfirmModal = true;
      },

      async onConfirmAction() {
         const id = this.pendingDeleteId;
         this.pendingDeleteId = null;
         if (!id) return;
         await this.$axios.delete("/groups/"+id)
         .then((response) => {
            if(response.data.success){
               this.$toast.success(response.data.message)

               this.$emit('onSubmit')
            } else {
               this.$toast.error(response.data.message)
            }
         })
         .catch((error) => {
            this.$toast.error(error.response.data.message)
         })
      },

      checkError(error) {
         if(error.response.data.message == "Group Name already exists."){
            this.isUnique.name = false
         } else if(error.response.data.message == "Display Name already exists."){
            this.isUnique.displayName = false
         } else {
            this.$toast.error(error.response.data.message)
         }
      },

   }
})
</script>

<style scoped>

.btn {
   width: 7rem;
}

</style>